import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/interfaces/api-response';
import { SharedDirectory } from 'src/app/interfaces/shared-directory';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SharedDirectoryService {

    private apiURL = environment.appApiUrl + "sharedDirectory/";

    constructor(private http: HttpClient) { }

    add(mail: string): Observable<ApiResponse> {
        const body = {"mail": mail};
        return this.http.post<ApiResponse>(this.apiURL + 'add', body);
    }

    remove(id: string): Observable<ApiResponse> {
        const body = {"id": id};
        return this.http.post<ApiResponse>(this.apiURL + "remove", body);
    }

    getShared(): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.apiURL + "getShared");
    }

    getAccess(): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.apiURL + "getAccess");
    }

    updateColor(id: string, color: string): Observable<ApiResponse> {
        const body = {"id": id, "color": color}
        return this.http.post<ApiResponse>(this.apiURL + "updateColor", body);
    }
}
